"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailServiceMessage = void 0;
var email_service_message_1 = require("./email-service-message");
Object.defineProperty(exports, "EmailServiceMessage", { enumerable: true, get: function () { return email_service_message_1.EmailServiceMessage; } });
